import { Tooltip } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { CODE_GROUP_ID, LOGIN_PATH, ROLE, USER_INFO_PATH } from '../constant/Constant';
import { actionLogout } from '../module/LoginModule';
import AuthenticationUtil from '../util/AuthenticationUtil';
import CodeUtil from '../util/CodeUtil';
import PathUtil from '../util/PathUtil';

const LocalSelection = ({ value, options, onChange }) => {
    return (
        <select style={{ width: 120, textAlign: 'center' }} value={value} onChange={onChange}>
            {options.map((option, index) => (
                <option key={index} value={option.cd}>
                    {option.cdNm}
                </option>
            ))}
        </select>
    );
};

const HeaderTop = ({ webType }) => {
    const { logged } = useSelector((state) => state.loginState);
    const [userId, setUserId] = useState('');
    const [userNm, setUserNm] = useState('');
    const [universityCd, setUniversityCd] = useState('');
    const [universityNm, setUniversityNm] = useState('');
    const [userRoleCd, setUserRoleCd] = useState('');
    const [prevUserNm, setPrevUserNm] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        setUserId(AuthenticationUtil.getUserId());
        setUserNm(AuthenticationUtil.getUserNm());
        setUniversityCd(AuthenticationUtil.getUserUniversityCd());
        setUniversityNm(AuthenticationUtil.getUserUniversityNm());
        setUserRoleCd(AuthenticationUtil.getUserRoleCd());
        setPrevUserNm(AuthenticationUtil.getPrevUserNm());
    }, [logged]);

    useEffect(() => {
        universityCd && AuthenticationUtil.setUserUniversityCd(universityCd);
        universityCd && setUniversityNm(CodeUtil.getCodeName(CODE_GROUP_ID.USER_UNIVERSITY, universityCd));
        universityCd &&
            AuthenticationUtil.setUserUniversityNm(CodeUtil.getCodeName(CODE_GROUP_ID.USER_UNIVERSITY, universityCd));
    }, [universityCd]);

    const handleLogout = () => {
        dispatch(actionLogout({ data: { forceLogout: false }, msg: '로그아웃 하였습니다.' }));
    };

    const hadnleLogin = () => {
        navigate(LOGIN_PATH);
    };

    const handleUserInfo = () => {
        const path = PathUtil.pushState(USER_INFO_PATH, {
            userId,
        });
        navigate(path);
    };

    // student teacher
    return (
        // <div className={`header-top ${webType}`}>
        <div className='header-top'>
            <div className='header-top-inner'>
                <ul className='top-menu'>
                    <li className='top-menu-list'>
                        {logged ? (
                            <div className='top-menu-box'>
                                {userRoleCd == ROLE.ADMIN ? (
                                    <>
                                        {/* <LocalSelection
                                            value={universityCd}
                                            options={CodeUtil.getCodes(CODE_GROUP_ID.USER_UNIVERSITY)}
                                            onChange={(e) => setUniversityCd(e.target.value)}
                                        /> */}
                                        <div className='header-univ-text'>
                                            <span>시스템관리자</span>
                                        </div>
                                        <div className='header-name-text' onClick={handleUserInfo}>
                                            {userNm}
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className='header-univ-text'>
                                            <span>{universityNm}</span>
                                        </div>
                                        <div className='header-name-text' onClick={handleUserInfo}>
                                            {userNm && prevUserNm ? userNm + '(' + prevUserNm + ' 전환)' : userNm}
                                        </div>
                                    </>
                                )}
                                <Tooltip title='로그아웃'>
                                    <button className='header-logout' onClick={handleLogout} />
                                </Tooltip>
                            </div>
                        ) : (
                            <div className='top-menu-box'>
                                <div className='header-name-text' onClick={hadnleLogin}>
                                    로그인
                                </div>
                                <Tooltip title='로그인'>
                                    <button className='header-login' onClick={hadnleLogin} />
                                </Tooltip>
                            </div>
                        )}
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default HeaderTop;
